var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmoker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM10.3087 5.11988C11.6379 5.39891 11.9346 6.49979 11.9992 7.05784C12.0104 7.16945 11.8967 7.24302 11.8208 7.17199C11.4151 6.80332 10.901 6.71127 10.3611 6.61461C9.73452 6.50244 9.07332 6.38406 8.50671 5.81998C7.66143 4.98037 8.06954 3.811 8.33717 3.26563C8.38848 3.16163 8.5223 3.18699 8.5446 3.30114C8.64275 3.8389 9.00403 4.84593 10.3087 5.11988ZM3.2 8.8C3.2 8.35817 3.55817 8 4 8H9.6V10.4H4C3.55817 10.4 3.2 10.0418 3.2 9.6V8.8ZM12 8H10.4V10.4H12C12.4418 10.4 12.8 10.0418 12.8 9.6V8.8C12.8 8.35817 12.4418 8 12 8Z",
    fill: "#8E93AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoker);
export default __webpack_public_path__ + "static/media/smoker.bbc24b08c65dca8d32bbabc48a1434ed.svg";
export { ForwardRef as ReactComponent };